import { createApp, createVNode, render } from 'vue';
import Components from '@/core/components'
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon'
import { converToCamelCase } from '@/core/util'
import Store from '@/store'

/* global
  __application_session__
  __application_version__
  __application_authenticated__
  __application_legacy_base__
  __application_legacy_images__
  __application_legacy_scripts__
  __application_legacy_styles__
  __application_legacy_date_format__
  __application_legacy_time_format__
  __application_legacy_phone_format__
  __application_csrf_token__
  __application_webtrac_app__
*/
export default {

  initialized: false,
  vm_id: 0,
  vueAppContext: null,
  domSyncEvent: null,
  domSyncElements: [],

  // Initialize the legacy framework, most of this is copied from the js/WebTrac/config.js which is 
  // taken out so that the processes are completely separate and do not affect each other.
  init( ) {
    const requiredFiles = [ 
      "shared/plugins.js", 
      "control.js", 
      "model.js", 
      "view.js",

      // Load views
      "WebTrac/view/webaddtocart.js",
      "WebTrac/view/webcart.js",
      "WebTrac/view/webcheckout.js",
      "WebTrac/view/webdonation.js",
      "WebTrac/view/webhousehold.js",
      "WebTrac/view/websearch.js",
      "WebTrac/view/webiteminfo.js",
      "WebTrac/view/webteams.js",
      "WebTrac/view/webschedule.js",
      "WebTrac/view/webhistory.js",
      "WebTrac/view/webautodebit.js",
      "WebTrac/view/webbillingupdate.js",
      "WebTrac/view/webmemberships.js",
      "WebTrac/view/webform.js",
      
      // Load models
      "WebTrac/model/multiselect.js",
      "WebTrac/model/share.js",
      "WebTrac/model/subtypes.js",
      "WebTrac/model/wishlist.js",
      "WebTrac/model/comments.js",
    ]

    if ( !App ) {
      alert("Unable to load WebTrac framework")
      return
    }
    
    // already initialized no need to continue
    if ( this.initialized ) {
      return
    }
    
    // Set the flag so we know not to load the config that this file will do all the
    // Legacy framework setup.
    App.loadConfig = false;
    
    // Set default Application settings (Taken from config.js)
    $.extend(App.settings, {
      Product: "WebTrac",
      Version: __application_version__,
      SessionID: __application_session__,
      BaseHref: __application_legacy_base__,
      ImagePath: __application_legacy_images__,
      ScriptPath: __application_legacy_scripts__,
      StylePath: __application_legacy_styles__,
      LoggedIn: __application_authenticated__,
      DateFormat: __application_legacy_date_format__,
      TimeFormat: __application_legacy_time_format__,
      PhoneFormat: __application_legacy_phone_format__,
      ScriptVersion: __application_version__,
      CSRFToken: __application_csrf_token__,
      WebTracApp: __application_webtrac_app__,
      DebugLevel: 0,
      NextGen: true
    })
    
    // Set a global class that this is the WebTrac App
		if (__application_webtrac_app__) {
			$("body").addClass("webtrac-app");
		}

    // Set the default localization
    App.localization("en-us");

    App.define("nextgen.components", [], ($parent) => {
      this.createComponents($parent)
    })

    // Initialization Event
    App.define("init", requiredFiles, function( ){
      App.run("view.common.apply", $("body"));
    });

    // Initialize the application
    App.init();

    // Create legacy components
    this.initializeDomSync()

    // Scroll to the top of the page
    setTimeout(function () {
      window.scrollTo(0, 1);
    }, 1000);

    // Create the nextgen overlay component
    this.createOverlay();

    // Flag that legacy code has been initialized
    this.initialized = true
    return true;
  },

  createComponents( $parent ) {
    this.createCombobox( $parent )
    this.createCheckbox( $parent )
    this.createDatepicker( $parent )
    this.createTimePicker( $parent )
    this.createMobileMenu( $parent )
    this.createSocialLinks( $parent )
    this.createFileUpload( $parent )
    this.createMultipleFileUpload( $parent )
    this.createThreads( $parent )
    this.createThreadMessages( $parent )
    this.createSignature( $parent )
  },

  createSocialLinks( $parent ) {
    this.queryComponent($parent, "div[data-component='social-links']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "social-links", "social-links-component", ( props ) => {
        props.facebookLink = $element.attr("data-facebook-link")
        props.twitterLink = $element.attr("data-twitter-link")
        props.linkedinLink = $element.attr("data-linkedin-link")
        props.youtubeLink = $element.attr("data-youtube-link")
        props.instagramLink = $element.attr("data-instagram-link")
        return props
      })
    })
    return true
  },
  
  createMobileMenu( $parent ) {
    this.queryComponent($parent, ".mobile-menu[data-component='mobile-menu']", ( el ) => {
      this.createComponent(el, "menu-button", "menu-button-component", null)
    })
    return true
  },

  createFileUpload( $parent ) {
    this.queryComponent($parent, ".fileupload", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "fileupload", "file-upload-component", ( props ) => {
        props.modelValue = new Blob([this.getValue($element)]);
        props.name = $element.attr("name");
        props.blobFileName = $element.attr("blobfilename");
        props.uploadAllowedExtensions = $element.attr("uploadallowedextensions");
        props.maxSize = parseInt($element.attr("maxsize"));
        props.required = $element.attr("data-rule-required");
        props.thumbImage = $element.attr("thumbImage");
        props.baseHref = $element.attr(App.settings.BaseHref);
        
        if ($element.attr("allowupdate") === 'true')
          props.allowUpdate = true;
        else 
          props.allowUpdate = false;

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
        }
        
        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }

        return props;
      })
    })
    return true
  },

  createMultipleFileUpload( $parent ) {
    this.queryComponent($parent, ".multiplefileupload", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "multiplefileupload", "multiple-file-upload-component", ( props ) => {
        props.modelValue = new Blob([this.getValue($element)]);
        props.name = $element.attr("name");
        props.blobFileName = $element.attr("blobfilename");
        props.uploadAllowedExtensions = $element.attr("uploadallowedextensions");
        props.maxSize = parseInt($element.attr("maxsize"));
        props.required = $element.attr("data-rule-required");
        props.thumbImage = $element.attr("thumbImage");
        props.baseHref = $element.attr(App.settings.BaseHref);

        if ($element.attr("allowupdate") === 'true')
          props.allowUpdate = true;
        else
          props.allowUpdate = false;

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
        }

        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }

        return props;
      })
    })
    return true
  },

  createThreads( $parent ) {
    this.queryComponent($parent, ".group[data-component='threads']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "threads", "threads-component", ( props ) => {
        props.threadHouseholdId = parseInt($element.attr("data-householdid"));

        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }

        return props;
      })
    })
    return true
  },

  createThreadMessages( $parent ) {
    this.queryComponent($parent, ".group[data-component='threadmessages']", ( el ) => {
      const $element = $(el)
      this.createComponent(el, "threadmessages", "thread-messages-component", ( props ) => {
        props.messageThreadIndex = parseInt($element.attr("data-threadid"));
                
        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }

        return props;
      })
    })
    return true
  },

  createDatepicker( $parent ) {
    this.queryComponent($parent, ".date[data-component='datepicker']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "datepicker", "datepicker-component", ( props ) => {
        props.modelValue = this.getValue($element)

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
        }
        
        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }

        return props
      })

      this.addDomSyncElement( $element, "datepicker", ( props ) => {
        instance.props.modelValue = props.modelValue
        instance.props.error = props.error
        instance.props.disabled = props.disabled
        instance.props.minDate = props.minDate
        instance.props.maxDate = props.maxDate
      })
    })
    return true
  },

  createSignature( $parent ) {
    this.queryComponent($parent, "[data-component='signature']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "signature", "signature-component", ( props ) => {
        props.modelValue = this.getValue($element)
        props.name = $element.attr("name");
        props.disabled = $element.attr("disabled");
        props.required = $element.attr("data-rule-required");
        props.savedSignature = $element.attr("signatureimage");
        
        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
        }
        
        props.onChange = ( value ) => {
          $element.val(value).trigger("change")
        }
        return props
      })

      this.addDomSyncElement( $element, "signature", ( props ) => {
        instance.props.modelValue = props.modelValue
        instance.props.error = props.error
        instance.props.disabled = props.disabled
      })
    })
    return true
  },

  createCheckbox( $parent ) {
    this.queryComponent($parent, ".checkbox[data-component='checkbox']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "checkbox", "checkbox-component", ( props ) => {
        props.modelValue = this.getValue($element)
        props.required = $element.attr("data-rule-required") === "true" ? true : false
        props.ariaLabel = $element.attr("aria-label")

        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
          $label.attr("for", `${props.id}_button`)
        }
        
        // Change event to update base element with value changes
        props.onChange = (checked) => {
          $element.prop("checked", checked).trigger("change")
        }

        return props
      })

      this.addDomSyncElement( $element, "checkbox", ( props ) => {
        instance.props.modelValue = props.modelValue
        instance.props.error = props.error
        instance.props.disabled = props.disabled
      })
    })
    return true
  },

  createCombobox( $parent ) {
    this.queryComponent($parent, ".combobox[data-component='combobox'], #gotopage", ( el ) => {
      const $element = $(el)
      const $label = $("label[for=" + $element.attr("id") + "]")
      const instance = this.createComponent(el, "combobox", "combobox-component", ( props ) => {
        props.modelValue = this.getValue($element)
        props.items = this.getOptionsArray($element)
        props.multiple = $element.is("[multiple]")

        // Update Label to point to new Vue Element (if there is a matching label)
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)

          if ( props.displayStyle === 'list' && props.multiple ) {
            const elementId = $element.attr("id") + "_count"
            $label.append('<span class="combobox-label-count" aria-hidden="true">(' + props.modelValue.length + ')</span>');
            $label.append('<span id="' + elementId + '" class="combobox-label-count sr-only""> Number of options selected: ' + props.modelValue.length + '.</span>');
            $label.siblings("button.filter-collapsible").attr("aria-describedby", elementId);
          }
        }

        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val( value ).trigger("change")

          if ( props.displayStyle === 'list' && props.multiple ) {
            $label.find(".combobox-label-count").text("(" + value.length + ")");
            $label.find(".combobox-label-count.sr-only").text("Number of options selected: " + value.length + ".");
          }
        }

        return props
      })

      this.addDomSyncElement( $element, "combobox", ( props ) => {
        instance.props.modelValue = props.modelValue
        instance.props.error = props.error
        instance.props.disabled = props.disabled
        instance.props.items = props.items
      })
    })

    return true
  },

  createTimePicker( $parent ) {
    this.queryComponent($parent, ".time[data-component='timepicker']", ( el ) => {
      const $element = $(el)
      const instance = this.createComponent(el, "timepicker", "timepicker-component", ( props ) => {
        props.modelValue = this.getValue($element)
        props.required = $element.attr("data-rule-required") === "true" ? true : false
        
        // Update Label to point to new Vue Element (if there is a matching label)
        const $label = $("label[for=" + $element.attr("id") + "]")
        if ( $label.length > 0 ) {
          $label.attr("id", `${props.id}_label`)
        }

        // Change event to update base element with value changes
        props.onChange = ( value ) => {
          $element.val( value ).trigger("change")
        }

        return props
      })

      this.addDomSyncElement( $element, ( props ) => {
        instance.props.modelValue = props.modelValue
        instance.props.error = props.error
        instance.props.disabled = props.disabled
        instance.props.minTime = props.minTime
        instance.props.maxTime = props.maxTime
        instance.props.step = props.step
      })
    })
    return true
  },

  createOverlay() {
    if ($("#nextgen-overlay").length > 0) {
      return;
    }

    const $overlay = $('<div id="nextgen-overlay" aria-live="assertive" aria-atomic="true"></div>').appendTo("body");

    this.createComponent($overlay[0], "overlay", "overlay-component");
  },

  createComponent( el, componentType, componentName, fnUpdateProps ) {
    const vm_id = this.getVmId( el )

    let component = Components.find((el) => el.name === componentName).component

    let props = this.getElementProps( $(el), componentType )

    props.id = vm_id

    if ( typeof fnUpdateProps === "function" ) {
      props = fnUpdateProps( props ) 
    }

    // Hide the existing element and create container for the Vue element
    let $el = $(`<div id="${vm_id}"></div>`)
    if (vm_id !== "menu-button" && vm_id !== "nextgen-overlay") {
      $(el).addClass("vue-component").hide().after($el)
    }
    else {
      el.id = vm_id + "-wrapper" // mobile menu button and overlay
    }

    // make sure a "global" app context is created
    if (!this.vueAppContext) {
      this.createVueAppContext()
    }

    let vNode = createVNode(component, props)
    vNode.appContext = this.vueAppContext

    let renderElement = (vm_id !== "menu-button" && vm_id !== "nextgen-overlay") ? $el[0] : el

    render(vNode, renderElement)

    return vNode.component
  },

  queryComponent( $parent, selector, fn ) {
    $(selector, $parent).not(".vue-component").each((i, el) => {
      if ( typeof fn === "function" ) {
        fn(el)
      }
    })
  },

  getVmId( el ) {
    if (el.id === "menu-button" || el.id === "nextgen-overlay")
      return el.id

    this.vm_id += 1
    return (el.id || el.tagName).toLowerCase() + "_vm_" + this.vm_id
  },

  getValue( $el ) {
    if ( !App.isjQuery($el) ) {
      return null
    }

    let value = $el.val()
    if ( $el.is("select") ) {
      if ( !value ) {
        return []
      } else if ( Array.isArray(value) ) {
        return value
      }
      return [ value ]
    }
    else if ( $el.is("input[type=checkbox]") ) {
      return $el.prop("checked")
    }

    return value
  },

  getOptionsArray( $el ) {
    const options = []
    if ( !App.isjQuery($el) || !$el.is("select") ) {
      return []
    }
    
    $el.find("option").each((i, opt) => {
      const $option = $(opt)
      options.push({
        value: $option.val(),
        label: $option.text()
      })
    })

    return options
  },

  getElementProps( $el, componentType, data ) {
    if ( !App.isjQuery($el) ) {
      return {}
    }

    let props = { ...data }

    props.modelValue = this.getValue($el)
    props.items = this.getOptionsArray($el)
    props.disabled = $el.is("[disabled]")
    props.error = $el.is(".error")

    for (let attr of $el[0].attributes) {
      if ( attr.name.startsWith("data-" + componentType) ) {
        const name = converToCamelCase(attr.name.replace("data-" + componentType + "-", ""))
        try {
          props[name] = JSON.parse(attr.value)
        } catch (err) {
          props[name] = attr.value
        }
      }
    }

    return props
  },

  addDomSyncElement( $el, componentType, fn ) {
    if ( !App.isjQuery($el) ) {
      return false
    }

    this.domSyncElements.push({
      element: $el,
      syncFunction: fn,
      componentType: componentType,
      props: this.getElementProps( $el, componentType, {} )
    })
  },

  initializeDomSync(  ) {
    clearInterval(this.domSyncEvent)

    // This interval is to sync DOM values to a Vue component
    this.domSyncEvent = setInterval(() => {

      const valueChanged = ( v1, v2 ) => {
        if ( typeof v1 !== typeof v2 ) return true
        if ( typeof v1 === "boolean" && v1 !== v2 ) return true
        if ( typeof v1 === "string" && v1 !== v2 ) return true
        if ( typeof v1 === "number" && v1 !== v2 ) return true
        if ( Array.isArray(v1) && JSON.stringify(v1) !== JSON.stringify(v2) ) return true
        return false
      }
 
      this.domSyncElements.forEach( o => {
        let changes = false
        const currentProps = this.getElementProps( o.element, o.componentType, o.props )
        
        Object.keys(currentProps).forEach( k => {
          if ( valueChanged(currentProps[k], o.props[k]) ) {
            changes = true
          }
        })

        // Changes were found so run sync function
        if ( changes && typeof o.syncFunction === "function" ) {
          o.syncFunction( currentProps )
        }

        o.props = currentProps
      })
    }, 10)

    return true
  },

  showMenu( show ) {
    if ( typeof show === "boolean" && show ) {
      $("body").addClass("menu--state-open");
    } else {
      $("body").removeClass("menu--state-open");
    }
  },
  
  createVueAppContext() {
    if (!this.vueAppContext) {
      const app = createApp({})
      app.use(VueSvgIconPlugin, { tagName: 'svgicon' })
      app.use(Store)
      this.vueAppContext = app._context
    }
  }
}